import * as React from 'react';
import type { DeliveryVoucherListResponse } from 'contracts/DeliveryVouchers';
import type {
  DeliveryVoucherFilters,
  DeliveryVoucherPaginationControl,
} from 'hooks/store/delivery-vouchers/use-delivery-vouchers-search-params';
import { createLinkAndDownload } from 'utils';
import { api, applyQueryString, handleApiError } from 'services/api';

type Payload = {
  filters?: DeliveryVoucherFilters;
  pagination?: DeliveryVoucherPaginationControl;
};

const getFileNameFromHeader = (contentDisposition?: string): string => {
  const fileName = contentDisposition?.match(/filename="?([^"]+)"?/)?.[1];
  return fileName || 'controle-comprovantes.xlsx';
};

export const useFetchDeliveryVoucherInvoices = () => {
  const fetchDeliveryVoucherInvoices = React.useCallback(
    async ({ filters, pagination }: Payload) => {
      const url = applyQueryString('/delivery-vouchers', {
        ...filters,
        ...pagination,
      });

      try {
        const { data } = await api.get<DeliveryVoucherListResponse>(url);
        return data;
      } catch (error) {
        throw handleApiError(error);
      }
    },
    []
  );

  const exportDeliveryVoucherInvoices = React.useCallback(
    async (filters?: DeliveryVoucherFilters) => {
      const url = applyQueryString('/delivery-vouchers/export', {
        ...filters,
      });

      try {
        const response = await api.get<Blob>(url, {
          responseType: 'blob',
        });
        const fileName = getFileNameFromHeader(
          response.headers['content-disposition']
        );
        const fileUrl = window.URL.createObjectURL(response.data);

        createLinkAndDownload(fileUrl, fileName);
        window.URL.revokeObjectURL(fileUrl);
      } catch (error) {
        throw handleApiError(error);
      }
    },
    []
  );

  return { fetchDeliveryVoucherInvoices, exportDeliveryVoucherInvoices };
};
